import get_title from "@/router/module/get_title";

export default {
  path: "/content",
  name: "start_page",
  component: () => import("@/views/Content/Main"),
  meta: {
    title: get_title("Стартовая страница"),
    forVisitors: true,
    requiresAuth: true
  }
}
